import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import { useNavigate } from "react-router-dom";
import { FaFilter } from "react-icons/fa";

function ParentList() {
  const [data, setData] = useState([]); // Common state for both lists
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("All"); // Tabs: "All" or "History"

  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === "All") {
      fetchParents();
    } else if (activeTab === "History") {
      fetchHistory();
    }
  }, [activeTab]);

  // Function to fetch All Parents
  const fetchParents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/parent/parents`);
      const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setData(sorted);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch Admission History
  const fetchHistory = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/parent/history`);
      setData(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this parent?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/parent/${id}`);
      fetchParents();
    } catch (err) {
      console.log("Delete Error:", err);
    }
  };

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      
      {/* IMAGE STYLE TABS */}
      <div className="d-flex align-items-center mb-1 shadow-sm" 
           style={{ borderRadius: "8px", overflow: "visible", backgroundColor: "#e9f7f4", border: "1px solid #d1e7e2" }}>
        
        {/* ALL TAB */}
        <div
          onClick={() => setActiveTab("All")}
          className="text-center py-3 fw-semibold"
          style={{
            flex: "1",
            backgroundColor: activeTab === "All" ? "#34a87b" : "transparent",
            color: activeTab === "All" ? "white" : "#555",
            cursor: "pointer",
            position: "relative",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px"
          }}
        >
          All
          {activeTab === "All" && (
            <div style={{
              position: "absolute", bottom: "-10px", left: "50%", transform: "translateX(-50%)",
              width: "0", height: "0", borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent", borderTop: "10px solid #34a87b", zIndex: "10"
            }}></div>
          )}
        </div>

        {/* ADMISSION HISTORY TAB (Replacement for Upcoming Expiry) */}
        <div
          onClick={() => setActiveTab("History")}
          className="text-center py-3 fw-semibold"
          style={{ 
            flex: "2", 
            cursor: "pointer", 
            borderLeft: "1px solid #d1e7e2",
            backgroundColor: activeTab === "History" ? "#34a87b" : "transparent",
            color: activeTab === "History" ? "white" : "#555",
            position: "relative"
          }}
        >
          Admission History
          {activeTab === "History" && (
            <div style={{
              position: "absolute", bottom: "-10px", left: "50%", transform: "translateX(-50%)",
              width: "0", height: "0", borderLeft: "10px solid transparent",
              borderRight: "10px solid transparent", borderTop: "10px solid #34a87b", zIndex: "10"
            }}></div>
          )}
        </div>

        {/* EXPIRED TAB (Optional - keeping for design) */}
        <div
          className="text-center py-3"
          style={{ flex: "1", color: "#888", cursor: "not-allowed", borderLeft: "1px solid #d1e7e2" }}
        >
          Expired
        </div>

        {/* FILTER ICON */}
        <div className="px-3 py-3 d-flex align-items-center" style={{ borderLeft: "1px solid #d1e7e2" }}>
           <div style={{ backgroundColor: "#dcf3ed", padding: "5px 10px", borderRadius: "5px", cursor: "pointer" }}>
              <FaFilter size={14} color="#34a87b" />
           </div>
        </div>
      </div>

      {loading ? (
        <h4 className="mt-5 text-center">Loading... ⏳</h4>
      ) : (
        <div className="table-responsive mt-4" style={{ borderRadius: "8px", border: "1px solid #e0e0e0" }}>
          <table className="table mb-0">
            <thead style={{ backgroundColor: "#e9f7f4" }}>
              <tr style={{ color: "#444", fontSize: "14px" }}>
                {activeTab === "All" ? (
                  <>
                    <th className="py-3 px-4 border-0">Name / Username</th>
                    <th className="py-3 border-0 text-center">Email ID</th>
                    <th className="py-3 border-0 text-center">Mobile Number</th>
                    <th className="py-3 border-0 text-center">Status</th>
                    <th className="py-3 border-0 text-end px-4">Action</th>
                  </>
                ) : (
                  <>
                    <th className="py-3 px-4 border-0">Parent Name</th>
                    <th className="py-3 border-0 text-center">Email</th>
                    <th className="py-3 border-0 text-center">Old School</th>
                    <th className="py-3 border-0 text-center">School Code</th>
                    <th className="py-3 border-0 text-end px-4">Date</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody className="bg-white">
              {data.map((item) => (
                <tr key={item._id} className="align-middle" style={{ fontSize: "14px", borderBottom: "1px solid #f0f0f0" }}>
                  {activeTab === "All" ? (
                    <>
                      <td className="py-3 px-4 fw-medium text-secondary">{item.name}</td>
                      <td className="py-3 text-center text-secondary">{item.email}</td>
                      <td className="py-3 text-center text-secondary">{item.mobile || "N/A"}</td>
                      <td className="py-3 text-center">
                        <span className="badge" style={{ backgroundColor: "#dcf3ed", color: "#34a87b" }}>Active</span>
                      </td>
                      <td className="py-3 text-end px-4">
                        <button className="btn btn-sm btn-info text-white me-2" onClick={() => navigate(`/dashboard/order/${item._id}`)}>Order Details</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item._id)}>Delete</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-3 px-4 fw-medium text-secondary">{item.parentId?.name}</td>
                      <td className="py-3 text-center text-secondary">{item.parentId?.email}</td>
                      <td className="py-3 text-center text-secondary">{item.oldSchool?.name}</td>
                      <td className="py-3 text-center text-secondary">{item.oldSchool?.schoolCode}</td>
                      <td className="py-3 text-end px-4 text-muted">{new Date(item.createdAt).toLocaleDateString()}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ParentList;